import {
  Box,
  Tabs,
  Tab,
  alpha
} from '@mui/material';
import {
  Translate as TranslateIcon,
  Search as SearchIcon} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

function a11yProps(index) {
  return {
    id: `readability-tab-${index}`,
    'aria-controls': `readability-tabpanel-${index}`,
  };
}

const TabNavBar = ({tabValue, handleTabChange}) => {
    const theme = useTheme();
    return (
       <Box sx={{ borderBottom: 1, borderColor: alpha(theme.palette.common.white, 0.1) }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="readability tools tabs"
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: theme.palette.primary.main,
                height: 3
              },
              '& .MuiTab-root': {
                color: theme.palette.text.secondary,
                '&.Mui-selected': {
                  color: theme.palette.primary.main
                }
              }
            }}
          >
            <Tab 
              label="Text Translation" 
              icon={<TranslateIcon />} 
              iconPosition="start"
              {...a11yProps(0)} 
            />
            <Tab 
              label="Text Lookup" 
              icon={<SearchIcon />} 
              iconPosition="start"
              {...a11yProps(1)} 
            />
            <Tab 
              label="Word Lookup" 
              icon={<SearchIcon />} 
              iconPosition="start"
              {...a11yProps(2)} 
            />
            {/* <Tab 
              label="Glyph Lookup" 
              icon={<SearchIcon />} 
              iconPosition="start"
              {...a11yProps(3)} 
            /> */}
          </Tabs>
        </Box>
    )
}

export default TabNavBar;